class Spot {
  static currentId = 1;

  static get nextId() {
    return this.currentId++;
  }

  static set nextId(nextId) {
    this.currentId = nextId;
  }

  static resetIds() {
    Spot.currentId = 1;
  }

  constructor({ x, y, wall = false }) {
    this.id = Spot.nextId;
    this.x = x;
    this.y = y;
    this.wall = wall;
    this.neighbors = [];
    this.start = false;
    this.end = false;
    this.resetSearch();
  }

  resetSearch() {
    this.previous = null;
    this.currentPathCost = Infinity;
    this.costToFinish = 0;
    this.totalCost = Infinity;
    this.isOpen = false;
    this.isClosed = false;
    this.isPath = false;
  }

  addNeighbors(grid) {
    const { x, y } = this;

    this.neighbors = [];

    for (
      let i = Math.max(0, x - 1);
      i <= Math.min(x + 1, grid.length - 1);
      i++
    ) {
      for (
        let j = Math.max(0, y - 1);
        j <= Math.min(y + 1, grid[0].length - 1);
        j++
      ) {
        if (x !== i || y !== j) {
          this.neighbors.push(grid[i][j]);
        }
      }
    }
  }
}

export { Spot };
